import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { OfflineDatabaseBrandGeneralSettings } from '../database/offlineDatabase/types/offlineDatabaseBrandGeneralSettings.types';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

const commonRepository = createOfflineCommonRepository<OfflineDatabaseBrandGeneralSettings, 'id'>(
  () => offlineDatabase.brandGeneralSettings,
);

export const offlineBrandGeneralSettingsRepository = {
  ...commonRepository,
  findByBrandId: (brandId: string) => {
    const databaseTable = offlineDatabase.brandGeneralSettings;
    return databaseTable.where('brandId').equalsIgnoreCase(brandId).first();
  },
  findByBrandIdOrFail: async (brandId: string) => {
    const brandGeneralSettings = await offlineBrandGeneralSettingsRepository.findByBrandId(brandId);
    if (!brandGeneralSettings) {
      throw new Error(`OfflineBrandGeneralSettings not found for brandId [${brandId}]`);
    }
    return brandGeneralSettings;
  },
};
